var map = {
	"./Classroom.png": "3254",
	"./Holiday.png": "e64d",
	"./SKLB-Alumnos.png": "4be0",
	"./SKLB-Citas.png": "afc1",
	"./SKLB-Colabordores.png": "9acc",
	"./SKLB-Comunidad.png": "1aa6",
	"./SKLB-Configuracion.png": "b212",
	"./SKLB-Dispositivos.png": "25aa",
	"./SKLB-Encuestas.png": "2aff",
	"./SKLB-Entregas.png": "e53b",
	"./SKLB-Entries.png": "e7db",
	"./SKLB-Estadisticas.png": "f7ec",
	"./SKLB-Grupos.png": "574d",
	"./SKLB-Help.png": "678b",
	"./SKLB-HorarioColab.png": "5391",
	"./SKLB-Incidencias 1.png": "683b",
	"./SKLB-Incidencias 2.png": "a4ac",
	"./SKLB-Mi Cuenta.png": "3a56",
	"./SKLB-Niveles.png": "5c58",
	"./SKLB-Pagos.png": "0ce0",
	"./SKLB-Registros.png": "ba84",
	"./SKLB-Reportes.png": "9e90",
	"./SKLB-Ronda.png": "e061",
	"./SKLB-Tutores.png": "b53e",
	"./SKLB-Updates.png": "3463",
	"./Workshop.png": "ce70",
	"./autorizar (3) 1.png": "1876",
	"./bus.png": "6192",
	"./sa_colleges_icon.png": "fba4"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "d76f";